export const sanitizeText = (text) => {
  if (typeof text === "string" && text.trim().length === 0) {
    return "";
  }
  return text?.replace(/[^\S\r\n]+/g, " ") || "";
};
